<section class="public-home">
  <div class="hero">
    <div class="hero-copy">
      <p class="eyebrow">{{ lang.translate('homePublic.hero.eyebrow') }}</p>
      <h1>{{ lang.translate('homePublic.hero.title') }}</h1>
      <p class="subtitle">{{ lang.translate('homePublic.hero.subtitle') }}</p>

      <div class="hero-actions">
        <a routerLink="/signup" class="btn primary">{{ lang.translate('homePublic.hero.ctaPrimary') }}</a>
        <a routerLink="/login" class="btn ghost">{{ lang.translate('homePublic.hero.ctaSecondary') }}</a>
      </div>

      <div class="hero-metrics" role="list">
        <div class="metric-card" *ngFor="let metric of heroMetrics" role="listitem">
          <span class="metric-value">{{ metric.value }}</span>
          <span class="metric-label">{{ lang.translate(metric.labelKey) }}</span>
        </div>
      </div>
    </div>

    <div class="hero-panel" aria-live="polite">
      <div class="panel-header">
        <p class="panel-eyebrow">{{ lang.translate('homePublic.mock.eyebrow') }}</p>
        <h3>{{ lang.translate('homePublic.mock.title') }}</h3>
        <p class="panel-description">{{ lang.translate('homePublic.mock.subtitle') }}</p>
      </div>

      <div class="mock-grid" role="list">
        <article class="mock-card" *ngFor="let signal of mockSignals" role="listitem">
          <span class="mock-label">{{ lang.translate(signal.labelKey) }}</span>
          <span class="mock-value">{{ signal.value }}</span>
          <span class="mock-detail" *ngIf="signal.detailKey">{{ lang.translate(signal.detailKey) }}</span>
          <span class="mock-trend" *ngIf="signal.trend" [class.positive]="signal.trend === 'up'" [class.negative]="signal.trend === 'down'">
            {{ signal.delta }}
          </span>
        </article>
      </div>
    </div>
  </div>

  <section class="features">
    <header>
      <p class="eyebrow">{{ lang.translate('homePublic.features.eyebrow') }}</p>
      <h2>{{ lang.translate('homePublic.features.title') }}</h2>
      <p class="subtitle">{{ lang.translate('homePublic.features.subtitle') }}</p>
    </header>

    <div class="feature-grid">
      <article *ngFor="let feature of featureList">
        <i [ngClass]="feature.icon" aria-hidden="true"></i>
        <h3>{{ lang.translate(feature.titleKey) }}</h3>
        <p>{{ lang.translate(feature.descriptionKey) }}</p>
      </article>
    </div>
  </section>

  <section class="plan-section">
    <div class="plan-copy">
      <p class="eyebrow">{{ lang.translate('homePublic.plan.eyebrow') }}</p>
      <h2>{{ lang.translate('homePublic.plan.title') }}</h2>
      <p class="subtitle">{{ lang.translate('homePublic.plan.subtitle') }}</p>

      <ul>
        <li *ngFor="let highlight of planHighlights">
          <h4>{{ lang.translate(highlight.titleKey) }}</h4>
          <p>{{ lang.translate(highlight.descriptionKey) }}</p>
        </li>
      </ul>
    </div>

    <div class="plan-cta">
      <div class="plan-card">
        <h3>{{ lang.translate('homePublic.plan.card.title') }}</h3>
        <p>{{ lang.translate('homePublic.plan.card.subtitle') }}</p>
        <div class="plan-card-actions">
          <a routerLink="/signup" class="btn primary">{{ lang.translate('homePublic.plan.card.ctaPrimary') }}</a>
          <a routerLink="/about-innovadoc-ia" class="btn ghost">{{ lang.translate('homePublic.plan.card.ctaSecondary') }}</a>
        </div>
      </div>
    </div>
  </section>

  <section class="testimonial">
    <blockquote>
      <p>“{{ lang.translate('homePublic.testimonial.quote') }}”</p>
      <footer>
        <span class="author">{{ lang.translate('homePublic.testimonial.author') }}</span>
        <span class="role">{{ lang.translate('homePublic.testimonial.role') }}</span>
      </footer>
    </blockquote>
  </section>

  <section class="cta-final">
    <div class="cta-card">
      <h2>{{ lang.translate('homePublic.cta.title') }}</h2>
      <p>{{ lang.translate('homePublic.cta.subtitle') }}</p>
      <div class="cta-actions">
        <a routerLink="/signup" class="btn primary">{{ lang.translate('homePublic.cta.primary') }}</a>
        <a routerLink="/login" class="btn ghost">{{ lang.translate('homePublic.cta.secondary') }}</a>
      </div>
    </div>
  </section>
</section>
